import { Button, Flex, Select } from "antd"
import type { BaseOptionType } from "antd/lib/select"
import { useMemo, useState } from "react"

import {
  UNRESOLVED_USER_LABEL,
  buildEntityLabelMap
} from "../../../../../utils/select/entity-labels.ts"
import { mergeSelectedIntoOptions } from "../../../../../utils/select/resolve-options.ts"
import type { LeadSalesManager } from "../../../../Lead/types/lead.types.ts"
import { type LeadsFilterOptions } from "../../../redux/leads.types.ts"

interface LeadsListPrimarySalesModalProps {
  filterOptions: LeadsFilterOptions
  selectedSales: (Pick<LeadSalesManager, "id" | "is_main"> &
    Partial<LeadSalesManager>)[]
  onClose: () => void
  onConfirm: (id: string) => void
}

export function LeadsListPrimarySalesModal({
  selectedSales,
  filterOptions,
  onClose,
  onConfirm
}: LeadsListPrimarySalesModalProps) {
  const [selectedId, setSelectedId] = useState<string | null>(null)
  const allSales = filterOptions?.["sales_manager"]

  const onFinish = () => {
    if (!selectedId) return
    onConfirm(selectedId)
  }

  // Dropping a rep the options list cannot resolve would leave them unpickable
  // as primary even though they are assigned to the lead.
  const options = useMemo(() => {
    const matched = selectedSales
      ?.map((selected) => allSales?.find((sale) => sale.value === selected.id))
      ?.filter(Boolean) as BaseOptionType[]

    return mergeSelectedIntoOptions(
      matched ?? [],
      selectedSales?.map((s) => s?.id),
      buildEntityLabelMap(selectedSales),
      UNRESOLVED_USER_LABEL
    )
  }, [selectedSales, allSales])

  return (
    <Flex vertical gap={"middle"}>
      <Select
        value={selectedId}
        options={options || []}
        className={"w-full"}
        onChange={setSelectedId}
        placeholder={"Select sales manager"}
        filterOption={(input, option) =>
          ((option?.label as string) ?? "")
            .toLowerCase()
            .includes(input?.toLowerCase())
        }
      />
      <Flex justify={"end"} gap={"small"}>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onFinish} disabled={!selectedId} type="primary">
          Confirm
        </Button>
      </Flex>
    </Flex>
  )
}
